import { useFeatureFlagEnabled } from "posthog-js/react";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;

export function useCanSeeLanguageSelector() {
  const canSeeLanguageSelector = useFeatureFlagEnabled("canSeeLanguageSelector");

  return canSeeLanguageSelector || ["dev"].includes(REACT_ENV);
}
